var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadmedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.591 7.36039H12.6644C11.0844 7.36039 9.79772 6.07372 9.79772 4.49372V2.56706C9.79772 2.20039 9.49772 1.90039 9.13105 1.90039H6.30438C4.25105 1.90039 2.59105 3.23372 2.59105 5.61372V11.5204C2.59105 13.9004 4.25105 15.2337 6.30438 15.2337H11.5444C13.5977 15.2337 15.2577 13.9004 15.2577 11.5204V8.02706C15.2577 7.66039 14.9577 7.36039 14.591 7.36039ZM9.11105 11.0871L7.77772 12.4204C7.73105 12.4671 7.67105 12.5071 7.61105 12.5271C7.55105 12.5537 7.49105 12.5671 7.42438 12.5671C7.35772 12.5671 7.29772 12.5537 7.23772 12.5271C7.18438 12.5071 7.13105 12.4671 7.09105 12.4271C7.08438 12.4204 7.07772 12.4204 7.07772 12.4137L5.74438 11.0804C5.55105 10.8871 5.55105 10.5671 5.74438 10.3737C5.93772 10.1804 6.25772 10.1804 6.45105 10.3737L6.92438 10.8604V8.06706C6.92438 7.79372 7.15105 7.56706 7.42438 7.56706C7.69772 7.56706 7.92438 7.79372 7.92438 8.06706V10.8604L8.40438 10.3804C8.59772 10.1871 8.91772 10.1871 9.11105 10.3804C9.30438 10.5737 9.30438 10.8937 9.11105 11.0871Z",
    fill: "#000014"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5444 6.44006C13.1777 6.44673 14.0577 6.44673 14.811 6.44673C15.191 6.44673 15.391 6.00006 15.1244 5.73339C14.1644 4.76673 12.4444 3.02673 11.4577 2.04006C11.1844 1.76673 10.711 1.95339 10.711 2.33339V4.66006C10.711 5.63339 11.5377 6.44006 12.5444 6.44006Z",
    fill: "#000014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadmedia);
export default __webpack_public_path__ + "static/media/downloadmedia.15ebaf6b928389969c915596a7172f52.svg";
export { ForwardRef as ReactComponent };